export default "__VITE_PUBLIC_ASSET__871ec090__"